import { useState, useEffect } from "react";
import TableCell from "@material-ui/core/TableCell";
import SaveIcon from "@mui/icons-material/Save";
import { IconButton, TextField } from "@mui/material";
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import TextPopUp from "../../../components/Pop_ups/TextPopUp";
import moment from "moment"
import {DatePicker} from "@mui/lab";
import LoadingPopUp from "../../../components/Pop_ups/LoadingPopUp";



export function EditableRow({ cell, isActive, setIsActive, selectedRow, editValues, setEditValues, refresh, setRefresh, setModifyExisting}) {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [success, setSuccess] = useState(false)
  useEffect(() => {
    let [value] = selectedRow.map((row) => row.original);
    setEditValues(value);
  }, []);
  
  const onChangeHandler=(event)=>{
    setEditValues({...editValues,[cell.column.id]: event.target.value,});
  }

  const onChangeDateHandler=(event)=>{
    setEditValues({...editValues,[cell.column.id]: event.format('YYYY-MM-DD')});
  }


  const handleClose = () => {
    cell.row.toggleRowExpanded();
    cell.row.toggleRowSelected();
    setIsActive(false);
  };
  const onSaveHandler=(e)=>{
    e.preventDefault();
        setLoading(true)
        if (editValues.po_number === '' || editValues.max_hours === '') {
            setLoading(false)
            setOpen(true)
            setMessage("Please complete the required sections of the form!")
        }
        setModifyExisting(true)
        setRefresh(true)
        handleClose()
    }
  
  return (
    <>
    <TextPopUp title="Success!" content={message} open={success} onClose={(event)=>{event.preventDefault(); setSuccess(false); setRefresh(!refresh);}} fullWidth/>
    <ErrorPopUp open={open} onClose={(e) => {e.preventDefault(); setOpen(false)}} errorContent={message} />
            <LoadingPopUp open={loading} />
    <TableCell align="center" {...cell.getCellProps()}>
      {cell.column.id === "edit" ? (
        <span>
          <IconButton sx={{ marginRight: 5 }} onClick={onSaveHandler}>
            <SaveIcon />
          </IconButton>
        </span>
      ):  cell.column.id === "Id" ? (
        ""
      ) :cell.column.id === "po_number" ||  cell.column.id === 'hours_max' ? 
      (<TextField
        helperText={!editValues[cell.column.id]? "required":' '}
        error={!editValues[cell.column.id]}
        value={editValues[cell.column.id]}
        required
        sx={{width:'100%', margin:0}}
        inputProps={{style: {fontSize: '0.875rem'}}} // font size of input text
            InputLabelProps={{style: {fontSize: '0.875rem'}}} 
        onChange={(event) => {onChangeHandler(event)}}
        variant="standard"
      ></TextField>): (cell.column.id === 'constraint_startdate' || cell.column.id === 'constraint_enddate') ? (
        <DatePicker 
          fullWidth
          label="Date"
          required
          value={editValues[cell.column.id] ? moment.utc(editValues[cell.column.id]).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
          onChange={(event) => {onChangeDateHandler(event)}}
          renderInput={(params)=><TextField fullWidth {...params}/>}/>)
        : <></>
      }
    </TableCell>
    </>
  );
}